export default __webpack_public_path__ + "static/media/icon-verified-blue.6956194f.svg";